import { Api } from '../../../../../providers/api';
import { Booking } from '../../../../../entities/booking';
import { Component } from '@angular/core';
import { DashboardPage } from '../../../../dashboard/dashboard';
import { MyBookingsPage } from '../../my-bookings';
import { NavController } from 'ionic-angular';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@Component({
  selector: 'page-booking-thank-you',
  templateUrl: 'booking-thank-you.html',
})
export class BookingThankYouPage {

    constructor(
        private api: Api,
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async goToDashboard() {
        this.spinner.show();
        let bookings: Booking[] = await this.api.getMyBookings();
        this.navCtrl.setRoot(DashboardPage, {bookings: bookings}, {animate: true, direction: 'back'});
        this.spinner.hide();
    }

    async goToMyBookings() {
        this.spinner.show();
        let bookings: Booking[] = await this.api.getMyBookings();
        this.navCtrl.setPages([
            {
                page: DashboardPage,
                params: {bookings: bookings}
            },
            {
                page: MyBookingsPage,
                params: {bookings: bookings}
            }
        ], {
            animate: true,
            direction: 'back'
        });
        this.spinner.hide();
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/create-booking/booking-thank-you/booking-thank-you.ts